<template>
  <modal name="recuperar-contrasena" :scrollable="true" :height="'auto'">
    <div class="container p-4">
        <div >
            <h2 class="text-center">Ingresa los datos</h2>
            <hr>
            <div class="col-md-10">
                <label  class="form-label">RFC registrado</label>
                <input type="text" class="form-control" id="validationCustom01" v-model="rfc" required>
            </div>
            <div class="mt-4 text-center">
                <button class="btn btn-primary col-4" @click="sendRFC">Aceptar</button>
            </div>
        </div>
    </div>
    </modal> 
</template>

<script>
export default {
    props: {
        invalidRFC: Boolean
    },
    data(){
        return{
            rfc: ''
        }
    },
    methods: {
        sendRFC(){
            this.$emit('RFCPassword', this.rfc);
        },
    }
}
</script>

<style>
.btn-primary{
    background-color: #1e536b !important;
    border-color: #1e536b !important;
    border-radius: 15px;
}
</style>